import axios from 'axios';
import { Buffer } from 'buffer';
import { useQuery } from 'react-query';

export const getCompanyLogoService = async (url: string | null): Promise<string | null> => {
  if (!url) return null;

  const resp = await axios.get<ArrayBuffer>(url, {
    responseType: 'arraybuffer',
  });

  if (resp?.data) {
    return Buffer.from(resp.data).toString('base64');
  }

  return null;
};

export const useCompanyLogo = (url: string | null) => {
  return useQuery<string | null, Error>(['useCompanyLogo', url], () => getCompanyLogoService(url), {
    cacheTime: 60000 * 60 * 3, // 3 hours cache
    staleTime: Infinity,
    enabled: !!url,
    refetchOnWindowFocus: false,
  });
};
